export default __webpack_public_path__ + "b5a8ffe19b438a84969a2b98a3e01595.svg";